import React from 'react';
import Card from './Card';

const cx = (...c) => c.filter(Boolean).join(' ');

// KPI tile for dashboards and demo pages.
// Props: label, value, icon (emoji or node), trend ({ dir: 'up'|'down', value }),
// hint (small sub-text), accent (hex bar color).
const StatCard = ({ label, value, icon, trend, hint, accent, className }) => {
  const trendUp = trend?.dir === 'up';
  return (
    <Card className={cx('p-5 relative overflow-hidden', className)}>
      {accent && (
        <span
          className="absolute left-0 top-0 h-full w-1"
          style={{ backgroundColor: accent }}
        />
      )}
      <div className="flex items-start justify-between">
        <p className="text-sm font-medium text-ink-500">{label}</p>
        {icon && <span className="text-lg leading-none">{icon}</span>}
      </div>
      <p className="mt-2 text-2xl sm:text-3xl font-bold font-display text-ink-900">
        {value}
      </p>
      <div className="mt-1 flex items-center gap-2">
        {trend && (
          <span
            className={cx(
              'inline-flex items-center text-xs font-semibold px-1.5 py-0.5 rounded-md',
              trendUp ? 'bg-emerald-50 text-emerald-600' : 'bg-red-50 text-red-600'
            )}
          >
            {trendUp ? '▲' : '▼'} {trend.value}
          </span>
        )}
        {hint && <span className="text-xs text-ink-400">{hint}</span>}
      </div>
    </Card>
  );
};

export default StatCard;
